import { Info } from "@mui/icons-material";
import { Box, IconButton, Tooltip } from "@mui/material";
import { SelectInput } from "components/HookFormComponents/SelectInput";
import { SwitchInput } from "components/HookFormComponents/SwitchInput";
import { TextInput } from "components/HookFormComponents/TextInput";
import React, { useMemo } from "react";
import { useFormContext } from "react-hook-form";
import { FormattedMessage, useIntl } from "react-intl";
import DisplaysUtils from "services/displays/utils";
import DisplayPictoForm from "./DisplayPictoForm";

function DisplayRuleForm({ display }) {
  const { watch } = useFormContext();
  const intl = useIntl();

  const toggleRule = useMemo(
    () =>
      (display?.available_texts?.length > 0 ||
        display?.is_text_freely_editable) &&
      display?.available_colors?.length > 0,
    [display]
  );
  const disabled = watch("stand_by");
  const ruleActivated = watch("rule.is_active");
  const currentTextSelected = watch("rule.text");

  const textItems = useMemo(() => {
    let items = display?.available_texts?.map((t) => ({
      label: t,
      value: t,
    }));
    if (display?.is_text_freely_editable) {
      items.push({
        label: intl.formatMessage({ id: "displaysScene.other" }),
        value: "custom",
      });
    }
    return items;
  }, [display?.available_texts, display?.is_text_freely_editable, intl]);
  return (
    <>
      {toggleRule && (
        <>
          <Box>
            <SwitchInput
              name="rule.is_active"
              label={intl.formatMessage({ id: "displaysScene.ruleForced" })}
              disabled={disabled || display.is_awol}
            />
            {disabled && (
              <Tooltip
                title={
                  <FormattedMessage id="displaysScene.ruleDisabledTooltip" />
                }
                followCursor
              >
                <IconButton
                  size="small"
                  disableRipple
                  sx={{ cursor: "default" }}
                >
                  <Info />
                </IconButton>
              </Tooltip>
            )}
          </Box>
          {ruleActivated && (
            <Box
              sx={{ display: "flex", flexDirection: "column", width: "100%" }}
            >
              <Box sx={{ display: "flex", flexDirection: "row", mt: 1 }}>
                <SelectInput
                  name="rule.color"
                  label={intl.formatMessage({ id: "displaysScene.color" })}
                  items={display?.available_colors?.map((c) => ({
                    label: intl.formatMessage({
                      id: `displaysScene.colors.${c.name}`,
                    }),
                    value: c.symbol,
                  }))}
                  sx={{ flex: 1 }}
                  required={ruleActivated}
                  disabled={disabled}
                />
                {textItems?.length > 1 && (
                  <SelectInput
                    name="rule.text"
                    label={intl.formatMessage({ id: "displaysScene.text" })}
                    items={textItems}
                    sx={{ flex: 1, ml: 1 }}
                    required={ruleActivated}
                    disabled={disabled}
                  />
                )}
                {DisplaysUtils.isCustom(currentTextSelected) &&
                  display?.is_text_freely_editable && (
                    <TextInput
                      name="rule.custom_text"
                      label={intl.formatMessage({
                        id: "displaysScene.customText",
                      })}
                      rules={{
                        required:
                          ruleActivated &&
                          DisplaysUtils.isCustom(currentTextSelected),
                        maxLength: display?.meta_data?.max_digits,
                      }}
                      sx={{ flex: 1, ml: 1 }}
                      disabled={disabled}
                    />
                  )}
              </Box>
              <DisplayPictoForm display={display} disabled={disabled} />
            </Box>
          )}
        </>
      )}
    </>
  );
}

export default DisplayRuleForm;
